import Vue from "vue"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome"
import createVipApp from "@zhoujianhui/vip-core"
import noticeManager from "@zhoujianhui/vip-notice-element"
import App from "./App"
import mockConfig from "../mock"
import "flag-icons/sass/flag-icons.scss"
import enterpriseManager from "./enterprise/enterprise-manager";

// 引入ElementUI
Vue.use(ElementUI, {
    size: "small",
});

// 引入图标组件
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

(async () => {
    const app = await createVipApp(App, [
            noticeManager // 通知管理器插件
        ], {
            mockConfig: mockConfig // mock配置
        }
    )

    if (app) {
        app.$mount("#app")
    }

    //设置当前用户信息
    await enterpriseManager.setCurrentUserEnterpriseInfo();

})()
